<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useWebOrderStore } from 'dashboard/stores/webOrder';
import SectionLayout from '../account/components/SectionLayout.vue';

const { t } = useI18n();
const route = useRoute();
const webOrderStore = useWebOrderStore();
const getAgentById = useMapGetter('agents/getAgentById');

const memberId = computed(() => Number(route.params.userId));

const agent = computed(() => {
  const fromVuex = getAgentById.value(memberId.value) || {};
  if (fromVuex.id) return fromVuex;
  return (
    webOrderStore.agents.find(item => Number(item.id) === memberId.value) || {}
  );
});

const roleLabel = computed(() => {
  const role = agent.value.role;
  if (agent.value.custom_role_id || agent.value.customRoleId) {
    return t('AGENT_HUB.ROLE_CUSTOM');
  }
  if (role === 'administrator') {
    return t('AGENT_MGMT.AGENT_TYPES.ADMINISTRATOR');
  }
  if (role === 'manager') return t('AGENT_MGMT.AGENT_TYPES.MANAGER');
  if (role === 'agent') return t('AGENT_MGMT.AGENT_TYPES.AGENT');
  if (role === 'custom_role') return t('AGENT_HUB.ROLE_CUSTOM');
  return '';
});
</script>

<template>
  <SectionLayout
    :title="t('AGENT_HUB.TABS.OVERVIEW')"
    :description="t('AGENT_HUB.OVERVIEW_NOTE')"
    class="!pt-0"
  >
    <dl class="grid gap-4 text-sm sm:grid-cols-2">
      <div>
        <dt class="text-n-slate-11">
          {{ t('PROFILE_SETTINGS.FORM.NAME.LABEL') }}
        </dt>
        <dd class="mt-1 text-n-slate-12">
          {{ agent.name || t('AGENT_HUB.EMPTY_VALUE') }}
        </dd>
      </div>
      <div>
        <dt class="text-n-slate-11">
          {{ t('PROFILE_SETTINGS.FORM.EMAIL.LABEL') }}
        </dt>
        <dd class="mt-1 break-all text-n-slate-12">
          {{ agent.email || t('AGENT_HUB.EMPTY_VALUE') }}
        </dd>
      </div>
      <div v-if="agent.display_name || agent.displayName">
        <dt class="text-n-slate-11">
          {{ t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.LABEL') }}
        </dt>
        <dd class="mt-1 text-n-slate-12">
          {{ agent.display_name || agent.displayName }}
        </dd>
      </div>
      <div v-if="roleLabel">
        <dt class="text-n-slate-11">
          {{ t('AGENT_MGMT.PROFILE.ROLE_LABEL') }}
        </dt>
        <dd class="mt-1 text-n-slate-12">
          {{ roleLabel }}
        </dd>
      </div>
    </dl>
  </SectionLayout>
</template>
